var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_762_22197)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#B2DEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5031 11C16.5731 11 12.5622 15.0109 12.5622 19.9409C12.5622 24.871 16.5731 28.8819 21.5031 28.8819C26.4332 28.8819 30.4441 24.871 30.4441 19.9409C30.4441 15.0109 26.4332 11 21.5031 11ZM32.6274 34.723C30.1795 32.2375 26.9345 30.8687 23.49 30.8687H19.5162C16.0718 30.8687 12.8267 32.2375 10.3789 34.723C7.94303 37.1962 6.60156 40.4609 6.60156 43.9159C6.60156 44.4645 7.04636 44.9093 7.595 44.9093H35.4112C35.9599 44.9093 36.4047 44.4645 36.4047 43.9159C36.4047 40.4609 35.0632 37.1962 32.6274 34.723Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_762_22197"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.309013dc88a59e1c347a44f01bac31f4.svg";
export { ForwardRef as ReactComponent };